import { Pipe, PipeTransform } from '@angular/core';
import { UserNamePipe } from './user-name.pipe';
@Pipe({
  name: 'nonVaultFormsNameFilter',
})
export class NonVaultFormsNameFilter implements PipeTransform {
  transform(
    fullList: any[] = [],
    filterText: string = '',
    users: string[] = [],
    selectedDateAddedList: string[] = [],
    selectedType: string[] = [],
    currentUserId?: string
  ): any[] {
    const userNamePipe = new UserNamePipe();

    // Separate items into forms and contacts
    const contactItems = fullList?.filter((item) => !item?.form_name);
    const formItems = fullList?.filter((item) => item?.form_name);

    let filteredList = [...formItems];

    // Apply text filter
    if (filterText?.trim().length > 0) {
      const text = filterText?.toLowerCase();

      const filteredForms = formItems?.filter((form) => form?.form_name?.toLowerCase()?.includes(text));

      const filteredContacts = contactItems?.filter((contact) => userNamePipe.transform(contact)?.toLowerCase()?.includes(text));

      filteredList = [...filteredForms, ...filteredContacts];
    } else {
      filteredList = [...filteredList, ...contactItems];
    }

    // Apply user filter
    if (users?.length && !users.includes('All')) {
      filteredList = filteredList.filter((item) => item?.sharedUsers?.some((s) => users?.includes(s.user_id)));
    }
    // if currentUserId set it to the first item in the filteredList
    if (currentUserId) {
      const currentUser = filteredList.find((item) => item?.id === currentUserId);
      if (currentUser) {
        filteredList = filteredList.filter((item) => item?.id !== currentUserId);
        filteredList.unshift(currentUser);
      }
    }
    if (selectedDateAddedList?.length) {
      filteredList = filteredList.filter((item) => selectedDateAddedList.includes(item.formatted_updated_at));
    }
    if (selectedType?.length) {
      filteredList = filteredList.filter((item) => selectedType.includes(item.type));
    }
    return filteredList;
  }
}
